// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"c825eb55","436":"b5fd5344"}[chunkId] + ".chunk.js";
};